"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WealthSecurityForFloridaFamilies() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2566" id="wealth-security-for-florida-families" className="dark bg-background text-foreground relative min-h-screen w-full overflow-hidden">
      {}
      <div className="pointer-events-none absolute inset-0" style={{
      background: "radial-gradient(ellipse 60% 50% at 85% 15%, hsla(43, 50%, 55%, 0.08), transparent 70%)"
    }} aria-hidden="true" />

      {}
      <div className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} aria-hidden="true" />

    <div className="relative mx-auto flex min-h-screen w-full max-w-[1440px] flex-col px-6 pt-24 pb-16 md:px-10 lg:flex-row lg:items-center lg:gap-12 lg:px-16 lg:py-24">
      {}
      <div ref={leftRef} className={`flex flex-col justify-center lg:w-[55%] transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        {}
        <div className="mb-8 flex items-center gap-3 font-mono text-[12px] uppercase tracking-[0.2em] text-primary"><span data-ast-id="f:/src/pages/Home/sections/WealthSecurityForFloridaFamilies.tsx|sig:ifmn67" data-ast-start="1947" data-ast-end="1966"><br /></span></div>

        <div className="mb-6">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/lwl logo-2.png" alt="Legacy Wealth Legal" className="h-64 w-auto" />
        </div>

        {}
        <h1 className="font-default font-semibold text-foreground" style={{
          fontSize: "clamp(3rem, 7vw, 7.5rem)",
          lineHeight: 0.95,
          letterSpacing: "-0.02em"
        }}>
          <span className="block">Wealth</span>
          <span className="block italic font-serif font-normal">Security for</span>
          <span className="block">
            Florida{" "}
            <span style={{
              color: "var(--primary)"
            }}>Families.</span>
          </span>
        </h1>

        {}
        <p className="mt-10 max-w-[480px] font-default text-base leading-relaxed text-muted-foreground md:text-lg">A family office approach to legal protection. We specialize exclusively in safeguarding your legacy through strategic estate planning and sophisticated asset preservation.</p>

        {}
        <div className="mt-12 flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:gap-10">
          <Button asChild size="lg" className="h-12 rounded-md bg-primary px-8 font-mono text-[12px] uppercase tracking-[0.1em] text-primary-foreground hover:bg-primary/90 shadow-md">
            <Link to="/ContactPage">Schedule a Legacy Review</Link>
          </Button>

          <Link to="/AssetProtectionPage" className="group inline-flex items-center gap-2 border-b border-primary/40 pb-1 font-default text-sm text-foreground transition-colors hover:border-primary hover:text-primary">
            <span>Explore Asset Protection</span>
            <ArrowRight className="size-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </div>

      {}
      <div ref={rightRef} className={`relative mt-0 lg:mt-0 lg:w-[45%] transition-all duration-1000 ease-out delay-200 ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="relative mx-auto w-full max-w-[520px]">
          {}
          <Link to="https://personalfamilylawyer.com" newTab className="block">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/placeholder.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/placeholder.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/placeholder.png-wvc-sizes" alt="Asset Protection Preview" loading="lazy" className="mx-auto mb-6 w-36 rounded-md object-cover shadow-lg transition-opacity !h-[80px] hover:opacity-90" src="https://legacywealthlegal.com/wp-content/uploads/2026/06/PFL-Logo2-1-scaled.jpg" src="https://legacywealthlegal.com/wp-content/uploads/2026/06/PFL-Logo1-1-scaled.jpg" />
          </Link>

          <div className="relative aspect-[4/5] w-full overflow-hidden rounded-md bg-muted shadow-xl">
            
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/florida_estate_architecture.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/florida_estate_architecture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/florida_estate_architecture.png-wvc-sizes" alt="Modern architectural detail of a high-end Florida estate at dusk" loading="lazy" decoding="async" className="h-full w-full object-cover grayscale-[20%] contrast-[110%]" src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/coastal_florida_dusk.png" />
            {}
            <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
              backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='3'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
            }} aria-hidden="true" />
            {}
            <div className="pointer-events-none absolute inset-0" style={{
              background: "linear-gradient(180deg, transparent 60%, hsla(215, 45%, 10%, 0.4))"
            }} aria-hidden="true" />
          </div>

          {}
          
        </div>
      </div>
    </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 lg:left-16 lg:translate-x-0">
        <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-muted-foreground"><br /></span>
        <div className="relative h-10 w-px overflow-hidden">
          <div className="absolute left-0 top-0 h-full w-px bg-foreground/30" aria-hidden="true" />
          <div className="absolute left-0 top-0 h-1/2 w-px bg-primary" style={{
          animation: "scrollLineDown 2s ease-in-out infinite"
        }} aria-hidden="true" />
        </div>
      </div>

      <style>{`
        @keyframes scrollLineDown {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
      `}</style>
    </section>;
}